import React from 'react';
import { values } from '../../mockData';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../ui/accordion';

const BatteriesSection = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">

        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-3">
            {values.map((value, index) => (
              <AccordionItem
                key={value.id}
                value={`item-${index}`}
                className="border border-gray-200 bg-white"
              >
                <AccordionTrigger className="px-6 py-4 hover:no-underline hover:bg-yellow-50 transition-colors">
                  <span className="font-bold text-gray-800 uppercase">
                    {value.title}
                  </span>
                </AccordionTrigger>

                <AccordionContent className="px-6 pb-4">
                  <p className="text-gray-600">{value.description}</p>
                </AccordionContent>

              </AccordionItem>
            ))}
          </Accordion>
        </div>

      </div>
    </section>
  );
};

export default BatteriesSection;
